import React from "react";

/**
 * Capless Funding wordmark-only logo.
 *  - "Capless." in editorial serif (Cormorant Garamond) with a subtle gold dot
 *  - "FUNDING" in clean tracked sans below
 *  - A short hairline rule on the left ties the two lines together
 *
 * Variants:
 *   variant="ink"   (default — dark navy ink on light surface)
 *   variant="paper" (white ink for use over dark/photo surfaces)
 */
const CFLogo = ({ variant = "ink", className = "", testId = "header-logo" }) => {
  const isPaper = variant === "paper";
  const inkColor = isPaper ? "#FFFFFF" : "#0F2540";
  const subColor = isPaper ? "rgba(255,255,255,0.78)" : "#26425E";
  const accentColor = "#B68A35";

  return (
    <a
      href="/"
      data-testid={testId}
      className={`inline-flex items-center gap-3 ${className}`}
      aria-label="Capless Funding home"
    >
      <span
        aria-hidden="true"
        className="block"
        style={{
          width: "2px",
          height: "30px",
          background: `linear-gradient(180deg, ${accentColor} 0%, rgba(182,138,53,0.2) 100%)`,
          borderRadius: "2px",
        }}
      />
      <span className="flex flex-col leading-[1] select-none">
        <span
          style={{
            fontFamily: '"Cormorant Garamond", Georgia, serif',
            fontSize: "1.45rem",
            fontWeight: 600,
            letterSpacing: "0.02em",
            color: inkColor,
            lineHeight: 1,
          }}
        >
          Capless<span style={{ color: accentColor, marginLeft: 1 }}>.</span>
        </span>
        <span
          style={{
            fontFamily: "Manrope, sans-serif",
            fontSize: "0.62rem",
            fontWeight: 600,
            letterSpacing: "0.36em",
            color: subColor,
            marginTop: "4px",
            textTransform: "uppercase",
          }}
        >
          Funding
        </span>
      </span>
    </a>
  );
};

export default CFLogo;
